import genderizeContacts from '../../libraries/genderize-contacts';

angular
    .module('festzelt-os.contacts')
    .factory('genderizeContacts', [
        'Alert',
        '$http',
        '$uibModal',
        (Alert, $http, $uibModal) => new genderizeContacts(Alert, $http, $uibModal)
    ]);




// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/list-view/genderize-contacts.js